<script>
  
  export default {
    components: {  },
    props: {
      solicitacoes: {
        required: true
      },
    },
    data() {
      return {
        solicitacaoSelecionada: null,
        salvandoLiberacao: false,
        animated: false,
      }
    },
    methods: {
      lista(pagina = 1) {
        this.solicitacoes.pagina = pagina;

        this.$emit('lista');
      },
    },
  }
</script>

<template>
  <div class="group">
    <h4 class="text-center">Sem solicitações para liberação</h4>

    <div class="hr-line-dashed margin-top-5"></div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-solicitacoes/componentes/compartilhado/LiberarSolicitacaoSemLista.vue